import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useTheme } from '@mui/material';

export enum RemediationFilterEnum {
  Reviewed = 'Reviewed',
  Rejected = 'Rejected',
  All = 'All',
}

const VerificationFilter = ({
  remediationFilter,
  setRemediationFilter,
}: {
  remediationFilter: string;
  setRemediationFilter: (value: RemediationFilterEnum) => void;
})=> {
  const theme = useTheme();

  return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', pr: 3, pb: 0, gap: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 500, color: theme.palette.customThemeColors?.darkGrey }}>
          Filter:
        </Typography>
        <ToggleButtonGroup
          value={remediationFilter}
          exclusive
          onChange={(e, newValue) => {
            if (newValue !== null) setRemediationFilter(newValue);
          }}
          size="small"
          sx={{
            '& .MuiToggleButton-root': {
              textTransform: 'none',
              fontSize: '13px',
              padding: '4px 12px',
              borderRadius: '8px',
              borderColor: '#ddd',
            },
          }}
        >
          <ToggleButton value={RemediationFilterEnum.All}>All</ToggleButton>
          <ToggleButton value={RemediationFilterEnum.Reviewed}>Reviewed</ToggleButton>
          <ToggleButton value={RemediationFilterEnum.Rejected}>Rejected</ToggleButton>
        </ToggleButtonGroup>
      </Box>
  );
};

export default VerificationFilter;

